import { OrganizationEditor } from '@/components/OrganizationEditor';
import { OrganizationDangerZone } from '@/components/organization/OrganizationDangerZone';
import { OrganizationShareLinks } from '@/components/organization/OrganizationShareLinks';
import { useOrganization } from '@/hooks/useOrganizations';
import { usePageMeta } from '@/hooks/usePageMeta';
import PageSkeleton from '@/layout/Skeleton';
import { useTranslation } from 'react-i18next';

export default function OrganizationSettings() {
  const organization = useOrganization();
  const { t } = useTranslation('orgSettings');
  usePageMeta({ title: [t('page.title')] });

  return (
    <PageSkeleton steps={[{ label: t('page.title'), href: '/settings' }]}>
      <div className='max-w-2xl mx-auto px-4 pt-6 w-full space-y-6'>
        <OrganizationEditor />
        <OrganizationShareLinks />
        {organization?.role === 'ADMIN' && <OrganizationDangerZone />}
      </div>
    </PageSkeleton>
  );
}
